import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollTriggerClass {
  constructor(el) {
    this.dom = {el: el};
    this.dom.header = document.querySelector('[data-scroller]');

    this.headerH = null;
    this.windowH = null;
    this.per = `0%`;

    this.resize = this.resize.bind(this)
    this.setStartPer = this.setStartPer.bind(this)

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    this.setStartPer();

    window.addEventListener('resize', this.setStartPer)

    document.body.classList.add('is-logo-white')

    ScrollTrigger.create({
      trigger: this.dom.el,
      id: 'message',
      start: `top ${this.per}`,
      toggleClass: {
        targets: document.body,
        className: 'is-logo-normal'
      },
      once: false,
      markers: false,
    });
  }

  resize() {
    this.setStartPer();
  }

  setStartPer() {
    this.windowH = window.innerHeight;
    this.headerH = this.dom.header.clientHeight;
    this.per = `${((this.headerH * .5) / this.windowH) * 100}%`;
  }
}

export default ScrollTriggerClass